import { TimeFrame } from 'types/analytics'

export const TIMEFRAME_LABELS: Record<TimeFrame, string> = {
  D: '24H',
  W: '7D',
  M: '30D',
}

// Bera mainnet analytics start (Jan 22, 2025 00:00:00 UTC)
export const ANALYTICS_CHART_START_TIMESTAMP = 1737504000
